<div class="d-flex align-items-center">
  <div class="keyword-column">
    <button class="btn btn-secondary me-4 btn-sm" type="button" (click)="removeKeyword()" title="Remove Keyword">
      <i class="fas fa-times fa-no-margin"></i>
    </button>
    {{ trackingKeywordSuggestion.KeywordPhrase }}
  </div>
  <div class="keyword-column-data">
    @if (trackingKeywordSuggestion.Volume !== null) {
      <span>Volume: {{ trackingKeywordSuggestion.Volume }}</span>
    }
  </div>
  <div class="keyword-column-data">
    @if (trackingKeywordSuggestion.CompetitionDescription) {
      <span>Competition: <span [ngClass]="{
        'text-warning': trackingKeywordSuggestion.CompetitionDescription === 'High' || trackingKeywordSuggestion.CompetitionDescription === 'Medium',
        'text-success': trackingKeywordSuggestion.CompetitionDescription === 'Low'}">{{ trackingKeywordSuggestion.CompetitionDescription }}</span>
      </span>
    }
  </div>
  <div class="keyword-column-data">
    @if (trackingKeywordSuggestion.Rank) {
      <span>Rank: {{trackingKeywordSuggestion.Rank}}</span>
    }
  </div>
  @if (validationMessage) {
    <div class="flex-grow-1 text-danger fw-normal me-3 text-end">
      {{ validationMessage.error }}
      @if(validationMessage.details) {
        <ng-template #content>
          <div [innerHTML]="validationMessage.details"></div>
        </ng-template>
        <span class="text-warning">
          <i class="fas fa-circle-info cursor-pointer" [ngbPopover]="content" placement="left auto" triggers="mouseenter:mouseleave"></i>
        </span>
      }
    </div>
  }
</div>